/**
 * Privacy Consent Checkbox Injector
 * Automatically adds a required consent checkbox to Shopify Forms App forms (Shadow DOM)
 * Does NOT inject into standard Liquid forms (those have checkboxes in templates)
 */
(function () {
    'use strict';

    const CHECKBOX_HTML = `
    <div class="privacy-consent-wrapper" style="margin: 8px 0 10px 0; direction: ltr; text-align: left; font-size: 13px; line-height: 1.4;">
      <label style="display: flex; align-items: flex-start; gap: 8px; cursor: pointer; justify-content: flex-start;">
        <input type="checkbox" class="privacy-consent-checkbox" style="height: 16px; width: 16px; min-width: 16px; accent-color: #202020; cursor: pointer; margin-top: 2px;">
        <span style="flex: 1;">
          I agree to receive marketing messages and accept the <a href="/policies/privacy-policy" target="_blank" style="text-decoration: underline; color: #1878b9;">Privacy Policy</a>.
        </span>
      </label>
    </div>
  `;

    function injectIntoShadowDOM() {
        // Find Shopify Forms App host element (only for Shadow DOM forms)
        const hosts = document.querySelectorAll('shopify-forms-embed');

        hosts.forEach(function (host) {
            if (!host.shadowRoot) return;

            const shadowRoot = host.shadowRoot;

            // Skip if already has our checkbox
            if (shadowRoot.querySelector('.privacy-consent-wrapper')) return;

            // Find the form and submit button inside shadow DOM
            const form = shadowRoot.querySelector('form[data-testid="form"], form');
            const submitButton = shadowRoot.querySelector('button[data-testid="btn-form-submit"], button[type="submit"]');

            if (form && submitButton) {
                // Create checkbox element
                const wrapper = document.createElement('div');
                wrapper.innerHTML = CHECKBOX_HTML.trim();
                const checkboxElement = wrapper.firstElementChild;

                // Insert before submit button
                submitButton.parentNode.insertBefore(checkboxElement, submitButton);

                // Get the checkbox input
                const checkbox = checkboxElement.querySelector('input[type="checkbox"]');

                // Intercept submit button click
                submitButton.addEventListener('click', function (e) {
                    if (!checkbox.checked) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        checkbox.style.outline = '2px solid #e02229';
                        checkbox.style.outlineOffset = '2px';

                        // Show error message below checkbox
                        let errorMsg = checkboxElement.querySelector('.consent-error');
                        if (!errorMsg) {
                            errorMsg = document.createElement('div');
                            errorMsg.className = 'consent-error';
                            errorMsg.style.cssText = 'color: #e02229; font-size: 12px; margin-top: 5px; text-align: left;';
                            errorMsg.textContent = 'Please check this box if you want to proceed.';
                            checkboxElement.appendChild(errorMsg);
                        }

                        checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        return false;
                    }
                }, true);

                // Remove error styling when checked
                checkbox.addEventListener('change', function () {
                    if (this.checked) {
                        this.style.outline = 'none';
                        const errorMsg = checkboxElement.querySelector('.consent-error');
                        if (errorMsg) errorMsg.remove();
                    }
                });
            }
        });
    }

    function injectAll() {
        // Only inject into Shadow DOM forms (Shopify Forms App)
        // Standard Liquid forms already have checkboxes in template code
        injectIntoShadowDOM();
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', injectAll);
    } else {
        injectAll();
    }

    // Observe for dynamically loaded forms
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.addedNodes.length) {
                setTimeout(injectAll, 100);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Retry for slow-loading forms (Shopify Forms loads async)
    setTimeout(injectAll, 500);
    setTimeout(injectAll, 1000);
    setTimeout(injectAll, 2000);
    setTimeout(injectAll, 3000);
    setTimeout(injectAll, 5000);
})();
